import { useState } from 'react'

import { IRoleEnum } from '../../../types/router'
import EditUser from '../EditUser/EditUser'
import UserContent from '../UserContent/UserContent'

import styles from './user.module.scss'
interface IUserProps {
    id: string
    name: string
    email: string
    role: IRoleEnum
}

function User(props: IUserProps) {
    const { id, name, email, role } = props

    const [isEditing, setIsEditing] = useState(false)

    return (
        <div className={styles.user}>
            {!isEditing ? (
                <UserContent
                    id={id}
                    name={name}
                    email={email}
                    role={role}
                    startEditing={() => setIsEditing(true)}
                />
            ) : (
                <EditUser
                    id={id}
                    name={name}
                    email={email}
                    role={role}
                    endEditing={() => setIsEditing(false)}
                />
            )}
        </div>
    )
}

export default User
